import classnames from "classnames";
import { URLS } from "../../../commun/routes.tsx";
import RessourceEntity from "../../Entities/RessourceEntity.tsx";
import TYPE_RESSOURCE from "../../enum/TypeRessource.tsx";
import { LinkButton, VARIANTS } from "../Button/Button.tsx";
import Loading from "../Elements/Loading/Loading.tsx";
import ViewWithToolbar from "../PdfReader/ToolbarPdf.tsx";
import CapsuleVideo from "../Video/Video.tsx";
import styles from "./Ressource.module.css";

type RessourceType = {
  ressource: RessourceEntity;
  type: TYPE_RESSOURCE;
};

/**
 * Composant React représentant une ressource.
 * Ce composant affiche une ressource sous plusieurs formes (PDF, VIDEO...), en fonction du type spécifié.
 * La ressource peut être téléchargeable ou non, et est définie par une entité RessourceEntity.
 */
const Ressource = ({
  ressource: { url, telechargeable = false, soustitre },
  type,
}: RessourceType) => {
  if (url == null) {
    return <Loading />;
  }
  switch (type) {
    case TYPE_RESSOURCE.VIDEO: {
      return (
        <CapsuleVideo
          telechargeable={telechargeable}
          url={url}
          soustitre={soustitre}
        />
      );
    }
    case TYPE_RESSOURCE.WEBGL: {
      return (
        <div className={classnames(styles.center, styles.height100)}>
          <div className={styles.entete}>Réalité virtuelle (2D)</div>
          En cliquant sur le bouton, un nouvel onglet va s&apos;ouvrir et vous
          permettra d&apos;accéder à la ressource.
          <br />
          Le premier chargement de la page peut prendre plusieurs minutes.
          <br />
          Une fois le premier chargement fait, l’accès à cette page sera plus
          rapide. Merci de votre compréhension
          <br />
          <p className={"text-muted fst-italic mt-3"}>
            La réalité virtuelle n&apos;est disponible ni sur mobile ni sur
            tablette.
          </p>
          <div className={styles.btnWebGl}>
            <LinkButton
              href={URLS.WEBGL}
              target="_blank"
              variant={VARIANTS.primary}
            >
              Accéder à la ressource
            </LinkButton>
          </div>
        </div>
      );
    }
    case TYPE_RESSOURCE.BD:
    case TYPE_RESSOURCE.PDF: {
      return <ViewWithToolbar url={url} telechargeable={telechargeable} />;
    }
  }
};

export default Ressource;
